export default function selectIntegrationsById(state) {
  return state.integrations.credentials.byId
}
